import IssueCredential from "./IssueCredential";

export default IssueCredential;
